var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 28,
    viewBox: "0 0 48 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 28,
    rx: 7,
    fill: "#E9F5EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.71 9.04C32.8027 8.94749 32.8762 8.8376 32.9264 8.71662C32.9766 8.59565 33.0024 8.46597 33.0024 8.335C33.0024 8.20403 32.9766 8.07435 32.9264 7.95338C32.8762 7.8324 32.8027 7.72251 32.71 7.63L30.37 5.29C30.17 5.09 29.92 5 29.66 5C29.4 5 29.15 5.1 28.96 5.29L27.13 7.12L30.88 10.87L32.71 9.04ZM15 19.25V23H18.75L29.81 11.94L26.06 8.19L15 19.25ZM17.92 21H17V20.08L26.06 11.02L26.98 11.94L17.92 21Z",
    fill: "#4F9B51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillEditIcon);
export default __webpack_public_path__ + "static/media/skill-edit-icon.9cb10474fd96b4b4f8fb3deecebf8841.svg";
export { ForwardRef as ReactComponent };